<template>
  <MIndex v-if="mobile"></MIndex>
  <header v-else class="header">
    <div class="container">
      <div class="logo">
        <!-- You can replace this with your actual logo -->
        <img src="./assets/logo.png" alt="Logo" />
      </div>
      <nav class="navigation">
        <div :class="{active: $route.path === `/`}" @click="changePage(`/`)">首页</div>
        <div :class="{active: $route.path.includes('/product')}" class="dropdown" @click="changePage(`/product`)">
          产品信息
          <ul class="dropdown-menu">
            <li :class="{active: $route.path === `/product/${item.value}/detail`}" v-for="item in product" :key="item.value" @click.stop="changePage(`/product/${item.value}/detail`)">
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div :class="{active: $route.path.includes('/sn')}" class="dropdown">
          走进首纳
          <ul class="dropdown-menu">
            <li :class="{active: $route.path === `/sn/${item.value}`}" v-for="item in toSn" :key="item.value" @click="changePage(`/sn/${item.value}`)">
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div :class="{active: $route.path.includes('/service')}" class="dropdown">
          客户服务
          <ul class="dropdown-menu">
            <li :class="{active: $route.path === `${item.value}`}" v-for="item in serviceArr" :key="item.value" @click="changePage(`${item.value}`)">
              {{ item.title }}
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { toSn, product, serviceArr } from '../../data'
import Browser from '@/utils/browser'
import MIndex from './m-index'

export default {
  components: { MIndex },

  data() {
    return {
      mobile: Browser.mobile,
      toSn,
      product,
      serviceArr
    }
  },

  mounted() {
    console.log(this.$route.path)
  },

  methods: {
    changePage(path) {
      if (path.startsWith('http')) {
        location.href = path
        return
      }
      if (path !== this.$route.path) {
        this.$router.push({ path })
      }
    }
  }
}
// Component logic goes here
</script>

<style scoped lang="scss">
.header {
  background-color: #2A2A2A; /* Adjust background color as needed */
  color: white;
  height: 100px;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px; /* Adjust max-width as needed */
  margin: 0 auto;
  height: 100%;
}

.logo img {
  width: 160px;
  display: block;
}
.navigation {
  height: 100%;
  display: flex;
}


.navigation > div {
  margin-left: 60px; /* Adjust spacing between nav items */
  position: relative; /* Needed for dropdown positioning */
  display: flex;
  align-items: center;
  padding: 5px 10px;
  font-size: 18px;/* px-to-viewport-ignore */
  color: #e0e0e0;
  cursor: pointer;

  &:hover {
    color: #f0ad4e;
  }
  &.active {
    color: #f0ad4e;
  }
}

/* Basic Dropdown Styles */
.dropdown-menu {
  display: none; /* Hide dropdown by default */
  position: absolute;
  top: 90px;
  left: -10px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px 0;
  list-style: none;
  width: 110px; /* px-to-viewport-ignore */
  z-index: 1000;
  text-align: center;
}

.dropdown:hover .dropdown-menu {
  display: block; /* Show dropdown on hover */
}

.dropdown-menu li {
  color: #333; /* Dropdown link color */
  padding: 8px 10px;
  display: block;
  white-space: nowrap;
  margin: 0;
  cursor: pointer;
  font-size: 14px;/* px-to-viewport-ignore */
}

.dropdown-menu a:hover {
  background-color: #f5f5f5; /* Dropdown link hover background */
}

/* Style for the active/highlighted nav item (example) */
.navigation li.active,
.navigation li:hover { /* Example using hover for highlight effect */
   color: #f0ad4e; /* Highlight color (yellowish) */
}

</style> 